import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TooltipWrapper = ({ children, tooltip }) => {
  return tooltip ? (
    <OverlayTrigger
      placement="auto-start"
      overlay={
        <Tooltip style={{ pointerEvents: 'none' }} id="Tooltip">
          {tooltip}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  ) : (
    <>{children}</>
  );
};
TooltipWrapper.displayName = 'TooltipWrapper';

export default TooltipWrapper;
